import moment from "moment";
import formatter from "../../tools/formatter.js";
import { DealBuilder } from "../services/deal-builder.ts";
import { ProductionUtils } from "../services/utils/production.utils.ts";

export default class DealBuilderSaverUtils {

  public static toCSVRowsNew(builder: DealBuilder) {
    const rows: any[] = [];

    for (const bond of builder.bonds) {
      const principal = ProductionUtils.getBondPrincipal(bond);
      const debtRow = builder.debtService.find(x => moment(x.date).isSame(moment(bond.maturity), "day"));
      const prodRow = builder.production.find(x => x.bond === bond);

      rows.push({
        "Date": moment(bond.maturity).format("MM/DD/YYYY"),
        "Principal": principal,
        "Term Bond": bond.type === "term",
        "Coupon Rate": bond.coupon,
        "Interest": debtRow ? Math.round(debtRow.accInterest) : "N/A",
        "Capitalized Interest": debtRow ? Math.round(debtRow.capitalizedInterest) : "N/A",
        "Yield Curve": prodRow ? formatter.float(prodRow.curve, 5) : "N/A",
        "Spread": prodRow ? formatter.float(prodRow.spread, 5) : "N/A",
        "Yield": prodRow ? formatter.float(prodRow.curve + prodRow.spread, 5) : "N/A",
        "YTM": prodRow ? formatter.float(prodRow.ytm, 5) : "N/A",
        "Price": prodRow ? formatter.float(prodRow.price, 3) : "N/A",
        "Production": prodRow ? Math.round(prodRow.production) : "N/A",
      })
    }

    return rows;
  }
}
